'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagKgAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.35587e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33334 20 0 20C3.62595e-06 13.3333 -7.89519e-05 6.66667 2.35587e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M2.35587e-05 0H28V20H0L2.35587e-05 0Z", fill: "#F22A46" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 13.3333C15.841 13.3333 17.3333 11.8409 17.3333 10C17.3333 8.15905 15.841 6.66667 14 6.66667C12.1591 6.66667 10.6667 8.15905 10.6667 10C10.6667 11.8409 12.1591 13.3333 14 13.3333Z",
          fill: "#FFF04D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.3682 17.1495L14 14.7136L15.6318 17.1495L16.0452 14.2468L18.5723 15.7334L17.6853 12.9389L20.6071 13.1818L18.5954 11.0489L21.3333 10L18.5954 8.95112L20.6071 6.81819L17.6853 7.06111L18.5723 4.26657L16.0452 5.75318L15.6318 2.85053L14 5.28639L12.3682 2.85053L11.9549 5.75318L9.42775 4.26657L10.3148 7.06111L7.3929 6.81819L9.40458 8.95112L6.66668 10L9.40458 11.0489L7.3929 13.1818L10.3148 12.9389L9.42775 15.7334L11.9549 14.2468L12.3682 17.1495ZM18.6667 10C18.6667 12.5773 16.5773 14.6667 14 14.6667C11.4227 14.6667 9.33334 12.5773 9.33334 10C9.33334 7.42267 11.4227 5.33333 14 5.33333C16.5773 5.33333 18.6667 7.42267 18.6667 10Z",
          fill: "#FFF04D"
        }
      )
    ]
  }
);
const VpFlagKgAsset = forwardRef(FlagKgAsset);

export { VpFlagKgAsset as default };
